import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import IconRadioUnselected from '../../icons/icon-radio-unselected.svg';
import IconRadioSelected from '../../icons/icon-radio-selected.svg';
import IconRadioDisabled from '../../icons/icon-radio-disabled.svg';
import isEnterOrSpace from '../../helpers/isEnterOrSpace';
import { FocusRing } from '@react-aria/focus';


const themeMap = {
  default: 'radio',
  filter: 'radio--filter',
};

const Radio = function RadioComponent(props) {
  const {
    fieldName,
    field,
    onChange,
    theme,
    disabled,
  } = props;
  const radioClass = classNames(themeMap[theme], {
    [`${themeMap[theme]}--selected`]: field.selected,
    [`${themeMap[theme]}--disabled`]: disabled,
  });
  const IconComponent = field.selected ? IconRadioSelected : IconRadioUnselected;

  return (
    <FocusRing focusRingClass="radio-focus-ring" within>
      <label
        htmlFor={field.id}
        className={radioClass}
        role="radio"
        aria-checked={field.selected}
        onKeyPress={event => isEnterOrSpace(event) && onChange(event, field.value)}
        onFocus={event => onChange(event, field.value)}
      >
        <input
          id={field.id}
          className="radio__input"
          type="radio"
          name={fieldName}
          value={field.value}
          checked={field.selected}
          disabled={disabled}
          onChange={event => onChange(event, field.value)}
          onFocus={event => onChange(event, field.value)}
          required={field.required}
        />
        { disabled && <IconRadioDisabled className="radio__icon-disabled" /> }
        <IconComponent className="radio__icon" />
        <span className="radio__label">{field.label}</span>
      </label>
    </FocusRing>

  );
};

Radio.propTypes = {
  field: PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    selected: PropTypes.bool,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.bool,
    ]),
    required: PropTypes.bool,
  }).isRequired,
  fieldName: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  theme: PropTypes.string,
  disabled: PropTypes.bool,
};

Radio.defaultProps = {
  onChange: () => {},
  theme: 'default',
  disabled: false,
};

export default Radio;
